import nprogress from 'nprogress';

require('typeface-roboto');
require('prismjs/themes/prism-tomorrow.css');

if (typeof document !== 'undefined') {
  nprogress.start();
}
